import varAxios from "../../Comman/axios";
import decode from 'jwt-decode';
import { UpdateUserPassword,resetPasswordUrl,CheckOneTimePassword } from "../../Comman/apiEndPoints"

export const RESET_USER_PASSWORD_REQUEST = "(login) RESET USER PASSWORD REQUEST";
export const RESET_USER_PASSWORD_SUCCESS = "(login) RESET USER PASSWORD SUCCESS";
export const RESET_USER_PASSWORD_ERROR = "(login) RESET USER PASSWORD ERROR";
 export const RESET_USER_PASSWORD_REQUEST12 = "RESET USER PASSWORD REQUEST12";
export const RESET_USER_PASSWORD_SUCCESS12 = "RESET USER PASSWORD SUCCESS12";
export const RESET_USER_PASSWORD_ERROR12 = "RESET USER PASSWORD ERROR12";

export const FETCH_USER_PASSWORD_REQUEST12 = "FETCH USER PASSWORD REQUEST12";

export function ResetUserPasswordSuccess12(isLoading,errorMessage,statusCode ) {
    debugger
    return {
        type: RESET_USER_PASSWORD_SUCCESS12,
        isLoading,
        errorMessage,
        statusCode
    }
}
export function FetchUserPasswordRequest12() {
    return {
        type: FETCH_USER_PASSWORD_REQUEST12,
        
    }
}
export function ResetUserPasswordRequest12( ) {
    let isLoading=true;
    return {
        type: RESET_USER_PASSWORD_REQUEST12,
        isLoading,
       
    }
}
export function ResetUserPasswordError12(isLoading,statusCode, errorCode, errorMessage ) {
    return {
        type: RESET_USER_PASSWORD_ERROR12,
        isLoading,
        statusCode,
        errorCode,
        errorMessage
    }
}

export function ResetUserPassword12(data,dispatch) {
    
    dispatch(ResetUserPasswordRequest12(true));
    return (dispatch) => {
       
        return varAxios.post(CheckOneTimePassword, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                debugger
                console.log(response)
                dispatch(
                    ResetUserPasswordSuccess12(
                        false,
                        response.data.errorMessage,
                        response.data.statusCode
                    ));
                
            })
            .catch((error) => {
                
                dispatch(
                    ResetUserPasswordError12(
                        false,
                        error.response.data.statusCode,
                       error.response.data.errorCode, 
                        error.response.data.errorMessage,
                    ));
            })

    }
}


export function ResetUserPasswordSuccess(isLoading,errorMessage,statusCode ) {
    return {
        type: RESET_USER_PASSWORD_SUCCESS,
        isLoading,
        errorMessage,
        statusCode
    }
}
export function ResetUserPasswordRequest( ) {
    let isLoading=false;
    return {
        type: RESET_USER_PASSWORD_REQUEST,
        isLoading,
       
    }
}
export function ResetUserPasswordError(isLoading,statusCode, errorCode, errorMessage ) {
    return {
        type: RESET_USER_PASSWORD_ERROR,
        isLoading,
        statusCode,
        errorCode,
        errorMessage
    }
}

export function ResetUserPassword(data,dispatch) {
    dispatch(ResetUserPasswordRequest(true));
    
    return (dispatch) => { 
        return varAxios.post(UpdateUserPassword, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    ResetUserPasswordSuccess(
                        false,
                        response.data.errorMessage,
                        response.data.statusCode
                    ));
                                return Promise.resolve(response.data);

            })
            .catch((error) => {
                
                dispatch(
                    ResetUserPasswordError(
                        false,
                        error.response.data.statusCode,
                       error.response.data.errorCode, 
                        error.response.data.errorMessage,
                    ));
            })

    }
}



